import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Controller } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';
import { isIOS, Option } from 'components/Option';
import styles from './styles';

const systems = [
  { value: 'google', label: 'Google Maps' },
  { value: 'samsara', label: 'Samsara' },
];

const NavigationSystemBlock = ({ classes, control, watch }) => (
  <div className={classes.root}>
    <Typography variant="h4" className={classes.heading}>
      Commercial Navigation System
    </Typography>
    <Controller
      name="navigationSystem"
      control={control}
      as={
        <TextField
          select
          id="navigationSystem"
          variant="outlined"
          className={classes.select}
          inputProps={{ 'aria-label': 'Commercial Navigation System' }}
          SelectProps={{ native: isIOS }}
        >
          {systems.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </TextField>
      }
    />
    {watch('navigationSystem') === 'samsara' && (
      <Alert severity="info" className={classes.alert}>
        <AlertTitle>Samsara app required</AlertTitle>
        If Samsara is selected, users must have the Samsara Driver app installed on their device. If
        the app is not installed, locations will open in Google Maps by default.
      </Alert>
    )}
  </div>
);

NavigationSystemBlock.propTypes = {
  classes: propTypes.object.isRequired,
  control: propTypes.object.isRequired,
  watch: propTypes.func.isRequired,
};

export default withStyles(styles)(NavigationSystemBlock);
